<template>
  <el-dialog
    :title="title"
    v-model="localVisible"
    :before-close="beforeClose"
    :data-testid="TEST_ID.APP_DIALOG.ROOT">
    <span>{{ message }}</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          type="primary"
          :data-testid="TEST_ID.APP_DIALOG.BUTTON_ACCEPT"
          @click="handleClose(true)">{{ confirmBtn || $t('GENERAL_acceptBtn') }}</el-button>
        <el-button
          class="btnConfirm"
          :data-testid="TEST_ID.APP_DIALOG.BUTTON_CANCEL"
          @click="handleClose(false)">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import TEST_ID from "@/testIds.json";

  export default {
    name: 'AppDialog',
    props: {
      visible: Boolean,
      title: String,
      message: String,
      cancelBtn: String,
      confirmBtn: String,
      onClose: Function
    },
    data() {
      return {
        TEST_ID,
        localVisible: false
      }
    },
    watch: {
      visible(newVal) {
        this.localVisible = newVal
      }
    },
    methods: {
      beforeClose(done) {
        this.handleClose(false)
        if (typeof done === 'function') {
          done()
        }
      },
      handleClose(confirm) {
        this.localVisible = false
        if (typeof this.onClose === 'function') {
          this.onClose(confirm)
        }
      }
    },
    mounted() {
      this.localVisible = this.visible
    }
  }

</script>

<style>

  .el-dialog {
    max-width: 700px;
  }

  .el-dialog__body {
    word-break: break-word;
  }

  @media(max-width: 400px)
  {
    .el-dialog__title {
      font-size: 16px !important;
    }
  }

  @media(max-width: 360px)
  {
    .el-dialog__footer button {
      width: 100%;
    }

    .el-dialog__footer button.btnConfirm {
      margin-left: 0px;
      margin-top: 10px;
    }
  }

</style>